export default "__VITE_ASSET__043548a8__"